<ng-container *ngIf="isModal;else CONTENT">
    <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
        <ng-container *ngTemplateOutlet="CONTENT"></ng-container>
        <div class="col-12 d-flex justify-content-end m-b-md">
            <button (click)="close()" class="btn btn-xs btn-secondary" type="button">
                <i class="fas fa-times" aria-hidden="true"></i> {{ 'General.close' | translate }} </button>
        </div>
    </p-scrollPanel>
</ng-container>
<!-- se trata del elemento que contiene la definicion de tags que han sido buscados, solamente visible para perfiles adminstradores -->
<div *ngIf="this.searchTags && this.userService.hasRoles('0,50')
      && this.userPrefs && this.userPrefs.mainViewPrefs && this.userPrefs.mainViewPrefs.showHelpTags;"
    class="alert alert-warning col-12">
    <div class="col-12">
        <span>Etiquetas contexto: </span>
        <ng-container *ngFor="let tag of searchTags">
            <span class=" badge badge-light border border-secondary d-inline-block m-r-sm">{{ tag }}</span>
        </ng-container>
    </div>
</div>
<ng-template #CONTENT>
    <ng-container *ngIf="groupedHelp && groupedHelp.length > 1; else CONTENT1GROUP">
        <div class="col-12 mb-2 p-0">
            <p-tabView>
                <p-tabPanel *ngFor="let grp of groupedHelp; let i = index" [selected]="i === 0">
                    <ng-template pTemplate="header"> {{ grp.groupId }} <span *ngIf="grp.helpElements" aria-hidden="true"
                            class="badge badge-warning m-l-1"> {{ grp.helpElements.length }} </span>
                    </ng-template>
                    <!-- SI SOLAMENTE HAY MAS DE 1 ELEMENTO SE UTILIZA EL TEMPLATE NO moreThanOneHelp-->
                    <ng-container *ngIf="grp.helpElements.length > 1 && !isFormFieldHelp()"
                        [ngTemplateOutlet]="moreThanOneHelp" [ngTemplateOutletContext]="{grp: grp}">
                    </ng-container>
                    <!-- SI SOLAMENTE HAY MAS DE 1 ELEMENTO EN CAMPO DE FORMULARIO SE UTILIZA EL TEMPLATE NO moreThanOneFieldHelp-->
                    <ng-container *ngIf="grp.helpElements.length > 1 && isFormFieldHelp()"
                        [ngTemplateOutlet]="moreThanOneFieldHelp" [ngTemplateOutletContext]="{grp: grp}">
                    </ng-container>
                    <!-- SI SOLAMENTE HAY 1 ELEMENTO SE UTILIZA EL TEMPLATE NO justOneHelp-->
                    <ng-container *ngIf="grp.helpElements.length === 1" [ngTemplateOutlet]="justOneHelp"
                        [ngTemplateOutletContext]="{element: grp.helpElements[0]}">
                    </ng-container>
                </p-tabPanel>
            </p-tabView>
        </div>
    </ng-container>
</ng-template>
<ng-template #CONTENT1GROUP>
    <ng-container *ngIf="groupedHelp && groupedHelp.length > 0; else noHelp">
        <div class="col-12 p-0">
            <!-- SI SOLAMENTE HAY MAS DE 1 ELEMENTO SE UTILIZA EL TEMPLATE NO moreThanOneHelp-->
            <ng-container *ngIf="groupedHelp[0].helpElements.length > 1 && !isFormFieldHelp()"
                [ngTemplateOutlet]="moreThanOneHelp" [ngTemplateOutletContext]="{grp: groupedHelp[0]}">
            </ng-container>
            <!-- SI SOLAMENTE HAY MAS DE 1 ELEMENTO EN CAMPO DE FORMULARIO SE UTILIZA EL TEMPLATE NO moreThanOneFieldHelp-->
            <ng-container *ngIf="groupedHelp[0].helpElements.length > 1 && isFormFieldHelp()"
                [ngTemplateOutlet]="moreThanOneFieldHelp" [ngTemplateOutletContext]="{grp: groupedHelp[0]}">
            </ng-container>
            <!-- SI SOLAMENTE HAY 1 ELEMENTO SE UTILIZA EL TEMPLATE NO justOneHelp-->
            <ng-container *ngIf="groupedHelp[0].helpElements.length === 1" [ngTemplateOutlet]="justOneHelp"
                [ngTemplateOutletContext]="{element: groupedHelp[0].helpElements[0]}">
            </ng-container>
        </div>
    </ng-container>
</ng-template>
<ng-template #justOneHelp let-element="element">
    <plyca-helpElement [helpElement]="element" [showTitle]="true"></plyca-helpElement>
</ng-template>
<ng-template #moreThanOneHelp let-grp="grp">
    <p-accordion>
        <div *ngFor="let element of grp.helpElements" class="help-element">
            <p-accordionTab>
                <p-header>
                    <i aria-hidden="true" class="fas fa-question-circle fa-lg mr-1 "></i>{{ element.name }} </p-header>
                <a *ngIf="element.externalLink" [attr.href]="element.externalLink" target="_blank">
                    <plyca-helpElement [helpElement]="element" [showTitle]="false"></plyca-helpElement>
                </a>
                <ng-container *ngIf="!element.externalLink">
                    <plyca-helpElement [helpElement]="element"></plyca-helpElement>
                </ng-container>
            </p-accordionTab>
        </div>
    </p-accordion>
</ng-template>
<ng-template #moreThanOneFieldHelp let-grp="grp">
    <div *ngFor="let element of grp.helpElements">
        <plyca-helpElement [helpElement]="element"></plyca-helpElement>
    </div>
</ng-template>
<ng-template #noHelp>
    <div class="col-12 p-md">
        <span>{{ 'Help.noHelp' | translate }}</span>
    </div>
</ng-template>